import { render, staticRenderFns } from "./pageLoading.vue?vue&type=template&id=cef80cb4&"
import script from "./pageLoading.vue?vue&type=script&lang=js&"
export * from "./pageLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports